/*
  FILE: assets/search-init.js

  HOW TO ADD:
  1. In Shopify Admin → Online Store → Themes → Edit Code
  2. Under "Assets" → Add a new asset → name it: search-init.js
  3. Paste this file and Save
  4. Then include it in your theme.liquid before </body> by adding:
     <script src="{{ 'search-init.js' | asset_url }}" defer></script>

  WHAT THIS DOES:
  - Shows the trending/brands/banners panel when search input is empty
  - Hides it when user starts typing (so results take over)
  - Works with Shopify Dawn theme and most standard themes
*/

(function () {
  'use strict';

  function initSearchEmptyState() {
    // These selectors work for Dawn theme — adjust if your theme differs
    const searchInputSelectors = [
      'input[name="q"][type="search"]',
      '.search__input',
      '#Search-In-Modal',
      'predictive-search input',
      '[data-predictive-search] input'
    ];

    const emptyStateSelectors = [
      '#sf-search-empty',
      '.sf-search-empty'
    ];

    // Find the search input
    let searchInput = null;
    for (const sel of searchInputSelectors) {
      searchInput = document.querySelector(sel);
      if (searchInput) break;
    }

    // Find our empty state panel
    let emptyState = null;
    for (const sel of emptyStateSelectors) {
      emptyState = document.querySelector(sel);
      if (emptyState) break;
    }

    if (!searchInput || !emptyState) return;

    function updateVisibility() {
      const hasValue = searchInput.value.trim().length > 0;
      if (hasValue) {
        emptyState.classList.add('is-hidden');
      } else {
        emptyState.classList.remove('is-hidden');
      }
    }

    searchInput.addEventListener('input', updateVisibility);
    searchInput.addEventListener('focus', updateVisibility);

    // Run once on load in case there's a pre-filled value
    updateVisibility();
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchEmptyState);
  } else {
    initSearchEmptyState();
  }

  // Also re-run when a modal/drawer opens (common in Dawn theme)
  document.addEventListener('shopify:section:load', initSearchEmptyState);

  // MutationObserver to catch dynamically injected search modals
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        initSearchEmptyState();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();
